import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class ClientUsersQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(): Promise<any> {
    let args = {
    }    
    let res = await this.dispatcher.dispatch('get.client.users', args)    
    if (res.promise['status'] === '200') {
      //this.frontend.client_users_facturae = res.promise['data']
      //Nos quedamos solamente con los que tienen los datos fiscales
      this.frontend.client_users_facturae = res.promise['data'].filter((client) => client['fiscal_data'] == true);
    } else {
      return res.promise['data']
    }    
  }
}